import script from "./FiltersMixin.vue?vue&type=script&lang=js"
export * from "./FiltersMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__